import authFetch from '../fetch';
import { getQueryParams, makeRequest } from '../utils';

export const routes = {
  policiesByCategoryPath: (categoryId, params) => `/api/Insurance/${categoryId}${getQueryParams(params)}`,
  policiesExportByCategoryPath: (categoryId, params) => `/api/Insurance/${categoryId}/export${getQueryParams(params)}`,
  policyByIdPath: (policyId) => `/api/Insurance/policy/${policyId}`,
  policyPath: () => '/api/Insurance',
  insuranceDocumentTypesPath: () => '/api/Insurance/DocumentTypes',
  insuranceCategoriesPath: () => '/api/Insurance/categories',
  insuranceTypesByCategoryPath: (categoryId) => `/api/Insurance/categories/${categoryId}/types`,
  insuranceRatingsPath: () => '/api/Insurance/ratings',
  insuranceSizeCategoriesPath: () => '/api/Insurance/sizeCategories',
};

export const getPoliciesByCategory = (categoryId, params) => makeRequest(authFetch.get(routes.policiesByCategoryPath(categoryId, params)));

export const getPoliciesForExportByCategory = (categoryId, params) => makeRequest(authFetch.get(routes.policiesExportByCategoryPath(categoryId, params)));

export const getPolicyById = (policyId) => makeRequest(authFetch.get(routes.policyByIdPath(policyId)));

export const putPolicy = (policy) => makeRequest(authFetch.put(routes.policyPath(), policy));

export const getPolicyFiles = (policyId, params) => makeRequest(
  authFetch.get(`/api/Insurance/${policyId}/Files${getQueryParams(params)}`),
);

export const postPolicyFiles = (policyId, files) => makeRequest(
  authFetch.post(`/api/Insurance/${policyId}/Files`, files),
);

export const getInsuranceDocumentTypes = () => makeRequest(authFetch.get(routes.insuranceDocumentTypesPath()));

export const getInsuranceCategories = () => makeRequest(authFetch.get(routes.insuranceCategoriesPath()));

export const getInsuranceTypesByCategory = (categoryId) => makeRequest(authFetch.get(routes.insuranceTypesByCategoryPath(categoryId)));

export const getInsuranceRatings = () => makeRequest(authFetch.get(routes.insuranceRatingsPath()));

export const getInsuranceSizeCategories = () => makeRequest(authFetch.get(routes.insuranceSizeCategoriesPath()));

export const getInsurancePolicyAudits = (id, params) => makeRequest(
  authFetch.get(`/api/Insurance/policy/${id}/Audits${getQueryParams(params)}`),
);

export const getInsurancePolicyAuditProperties = (id) => makeRequest(
  authFetch.get(`/api/Insurance/policy/${id}/Audits/Properties`),
);

export const getInsurancePolicyAuditUsers = (id) => makeRequest(
  authFetch.get(`/api/Insurance/policy/${id}/Audits/Users`),
);
